<template>
	<templateLogin>
		<div class="header" />

		<div class="body">
			<section class="box-login">
				<form v-on:submit="doCheckToken" action="#" method="post">
					<div class="title">
						<h1>{{title}}</h1>
						<p>{{text}}</p>
					</div>

					<div v-show="message.text"
						v-html="message.text"
						:class="{
							'message': message.type === 'error',
							'message-success': message.type === 'success',
							'mb-15': true
						}"/>

					<div>
						<ui-input v-model.trim="form.token" label="Código:" type="text" size="md3" ref="token" />
					</div>

					<div class="text">
						Não receu o código? <button :loading="status === 'loading'" type="button" @click="resendToken">Tentar novamente</button>
					</div>

					<div class="control">
						<ui-button type="submit" design="lg primary block" :class="status">Confirmar</ui-button>
					</div>

					<div class="back-link">
						<router-link to="/login"><i class="fal fa-long-arrow-left"></i> Voltar</router-link>
					</div>
				</form>
			</section>
		</div>
	</templateLogin>
</template>

<script>
	import templateLogin from '@/templates/page-login'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'

	import { resetPassword } from '@/services/axios'

	export default {
		components: { templateLogin, uiButton, uiInput },

		data() {
			return {
				title: 'Confirmar Código',
				text: 'Informe o código que enviamos em seu e-mail.',
				message: {
					text: '',
					type: 'success'
				},
				status: '',
				data: {
					userID: null,
					email: ''
				},
				form: {
					token: '',
				},
			}
		},

		created() {
			this.data.userID = this.$route.params.user_id
			this.data.email = this.$route.params.email
		},

		methods: {
			/**
			 * Solicita o reenvio do token de validação para o celular cadastrado
			 */
			resendToken() {
				this.status = 'loading'
				const params = {
					email: this.data.email
				}

				resetPassword.recover(params).then(response => {
                    if (response.data.status !== "error") {
                        this.data.userID = response.data.data.user_id
                    }
					this.message = {
						text: response.data.msg,
						type: response.data.status
					}
                    this.status = false
                })
			},
			/**
			 * Realiza uma requisição para validar o token de autenticaçao
			 */
			doCheckToken(event){
				event.preventDefault()
				this.status = 'loading'
				this.message = {
					text: '',
					type: 'success'
				}

				if (!this.form.token) {
					this.$refs.token.$el.classList.add('error')
					this.message = {
						text: 'Informe o token que enviamos para o seu e-mail.',
						type: 'error'
					}
					this.status = false
					return false
				}

				resetPassword.checkToken(this.data.userID, this.form.token)
					.then((response) => {
						if (response.data == "" || response.data.status !== "error") {
							this.$router.push({
								name: 'registerNewPassword',
								params: {
									userID: this.data.userID,
									token: this.form.token
								}
							})
						}
						this.message = {
							text: response.data.msg,
							type: response.data.status
						}
						this.status = false

					})
					.catch((error) => {

						this.message = {
							text: error.response.data.message,
							type: 'error'
						}
						console.log(error)

					})
			}
		}
	}
</script>
